import * as screeningDealSetupFields from "./constants";
import PrescreeningForApplicants from "./PrescreeningForApplicants";
import ScreeningForApplicantsAndOccupants from "./ScreeningForApplicantsAndOccupantsContainer";

export { PrescreeningForApplicants, screeningDealSetupFields };
export default ScreeningForApplicantsAndOccupants;
